var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"featured_text",style:(_vm.cssVars)},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"inner",class:_vm.theme,domProps:{"innerHTML":_vm._s(_vm.text)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /home/forge/clarencelifts.stagingwebsite.dev/web/app/themes/clarence-lifts/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/home/forge/clarencelifts.stagingwebsite.dev/web/app/themes/clarence-lifts/node_modules/vue-loader/lib?{}!./scripts/vue/FeaturedText.vue?vue&type=template&id=74b1004b&scoped=true&
// module id = 132
// module chunks = 0